var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5569 13.6364C25.5569 21.2045 20.2236 28.2818 13.0569 30C5.89022 28.2818 0.556885 21.2045 0.556885 13.6364V5.45455L13.0569 0L25.5569 5.45455V13.6364ZM13.0569 27.2727C18.2652 25.9091 22.7791 19.8273 22.7791 13.9364V7.22727L13.0569 2.97273L3.33466 7.22727V13.9364C3.33466 19.8273 7.84855 25.9091 13.0569 27.2727ZM16.9458 13.6364V11.5909C16.9458 9.68182 15.0013 8.18182 13.0569 8.18182C11.1124 8.18182 9.168 9.68182 9.168 11.5909V13.6364C8.33466 13.6364 7.50133 14.4545 7.50133 15.2727V20.0455C7.50133 21 8.33466 21.8182 9.168 21.8182H16.8069C17.7791 21.8182 18.6124 21 18.6124 20.1818V15.4091C18.6124 14.4545 17.7791 13.6364 16.9458 13.6364ZM15.1402 13.6364H10.9736V11.5909C10.9736 10.5 11.9458 9.81818 13.0569 9.81818C14.168 9.81818 15.1402 10.5 15.1402 11.5909V13.6364Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.35b14aee184919673875a49168523fca.svg";
export { ForwardRef as ReactComponent };